import { List } from 'immutable';
import { createSelector, lruMemoize } from 'reselect';

import { isResourceLoading } from './common';
import { EXCLUDED_PRODUCT_LINES } from '../global/appConstants';

const isProductShownInFilters = (p) => {
    const val = typeof p?.get === 'function' ? p.get('show_in_filters') : p?.show_in_filters;
    const hasAccess = typeof p?.get === 'function' ? p.get('has_access') : p?.has_access;
    return val !== false && hasAccess !== false;
};

const isProductsLoading = lruMemoize(isResourceLoading);
const getProducts = lruMemoize(
    (data) => {
        const products = data.getIn(['products'], List());
        return products.filter((p) => (
            !EXCLUDED_PRODUCT_LINES.includes(typeof p?.get === 'function' ? p.get('product_line') : p?.product_line)
            && isProductShownInFilters(p)
        ));
    },
);

const getAllProductsData = (state) => state.getIn(['app', 'allProducts']);
const isAllProductsLoading = createSelector(getAllProductsData, isResourceLoading);
const getAllProducts = createSelector(getAllProductsData, (data) => {
    const products = data.get('products', List()).toJS();
    return products.filter((p) => !EXCLUDED_PRODUCT_LINES.includes(p.product_line));
});

const getDropdownProductsData = (state) => state.getIn(['app', 'dropdownProducts']);
const isDropdownProductsLoading = createSelector(getDropdownProductsData, isResourceLoading);
const getDropdownProducts = createSelector(getDropdownProductsData, (data) => {
    const products = data.get('products', List()).toJS();
    return products.filter((p) => (
        !EXCLUDED_PRODUCT_LINES.includes(p.product_line)
        && p.show_in_filters !== false
        && p.has_access !== false
    ));
});

export {
    isAllProductsLoading,
    isDropdownProductsLoading,
    isProductsLoading,
    getAllProducts,
    getDropdownProducts,
    getDropdownProductsData,
    getProducts,
};
